import {
  AfterViewInit,
  ComponentFactoryResolver,
  ComponentRef,
  Directive,
  HostBinding,
  Input,
  OnDestroy,
  Renderer2,
  ViewContainerRef,
} from '@angular/core';
import { MatButton } from '@angular/material/button';
import {
  LoaderComponent,
  loaderSize,
  loaderTheme,
  loaderTypes,
} from '@x/common/loader/loader.component';
import { BehaviorSubject, Subscription } from 'rxjs';

@Directive({
  selector: 'button[xButtonLoading]',
})
export class ButtonLoadingDirective implements AfterViewInit, OnDestroy {
  private subscription = new Subscription();
  private loaderInstance: ComponentRef<LoaderComponent> | null = null;

  loading$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);

  get nativeElement(): HTMLElement {
    return this.matButton._elementRef.nativeElement;
  }

  @HostBinding('class.loading')
  _loading: boolean = false;

  @Input() loaderType: loaderTypes = 'circle';
  @Input() loaderTheme: loaderTheme = 'light';
  @Input() loaderSize: loaderSize = 'default';

  @Input()
  set xButtonLoading(loading: boolean | null) {
    if (loading === null) return;

    this._loading = loading;
    this.loading$.next(loading);
  }

  constructor(
    private renderer: Renderer2,
    private matButton: MatButton,
    private viewContainerRef: ViewContainerRef,
    private componentFactoryResolver: ComponentFactoryResolver,
  ) {}

  private createSpinner(): void {
    if (this.loaderInstance) return;

    const componentFactory = this.componentFactoryResolver.resolveComponentFactory(LoaderComponent);
    this.loaderInstance = this.viewContainerRef.createComponent(componentFactory);
    this.loaderInstance.instance.loader = this.loaderType;
    this.loaderInstance.instance.theme = this.loaderTheme;
    this.loaderInstance.instance.size = this.loaderSize;
    this.loaderInstance.instance.opacity = 0;
    this.loaderInstance.changeDetectorRef.detectChanges();
    this.renderer.appendChild(this.nativeElement, this.loaderInstance.location.nativeElement);
  }

  private destroySpinner(): void {
    if (!this.loaderInstance) return;

    this.loaderInstance.destroy();
    this.loaderInstance = null;
  }

  ngAfterViewInit(): void {
    this.subscription.add(
      this.loading$.subscribe((loading) => {
        loading ? this.createSpinner() : this.destroySpinner();
      }),
    );
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }
}
